export default __webpack_public_path__ + "media/hot-now.c8818348.png";